angular.module('impactx.validationbutton').service('ValidationTooltip', [
    '$mdPanel',
    '$timeout',
    ValidationTooltip
]);

function ValidationTooltip($mdPanel, $timeout) {
    var self = this;
    self.panelRef = null;
    self.errorData = {
        errorFields: undefined,
        errorFieldCounter: undefined,
        myErrorLists: undefined,
        disableExpressions: undefined,
        disableExpression: undefined,
    };

    var closePanelPromise;


    function open(event, errorData, yPositionTop) {
        if (!self.panelRef) {
            var panelAnimation = $mdPanel.newPanelAnimation()
                .openFrom(event.target)
                .closeTo(event.target);


            var tooltipConfig = {
                attachTo: angular.element(document.body),
                controller: 'ValidationTooltipCtrl',
                controllerAs: 'ctrl',
                animation: panelAnimation,
                locals: {
                    errorData: errorData
                },
                bindToController: true,
                position: $mdPanel.newPanelPosition()
                    .relativeTo(event.target)
                    .addPanelPosition(
                        $mdPanel.xPosition.CENTER,
                        yPositionTop ? $mdPanel.yPosition.ABOVE : $mdPanel.yPosition.BELOW
                    ),
                panelClass: 'tooltip-selection-panel',
                event: event,
                templateUrl: 'shared/savebutton/templates/validation-button-tooltip.html',
                propagateContainerEvents: true,
                focusOnOpen: false,
                clickOutsideToClose: true,
                onDomRemoved: function () {
                    self.panelRef.destroy();
                    self.panelRef = undefined;
                }
            };

            self.panelRef = $mdPanel.create(tooltipConfig);
        }

        if (!self.isOpen) {
            self.isOpen = true;
            self.isActive = true;
            self.panelRef.open().then(function () {
                var selectionPanel = document.getElementById("tooltip-selection-panel");
                var panelParent = impactX.isDefined(selectionPanel, 'parentElement.parentElement');
                if (panelParent) {
                    panelParent.className += " tooltip-selection-panel-parent";
                }
            });
        }
    }

    function hide() {
        self.isOpen = false;
        closePanelPromise = $timeout(function () {
            self.panelRef && self.panelRef.close();
        }, 100);
    }

    function cancelPromise() {
        $timeout.cancel(closePanelPromise);
    }

    return {
        open: open,
        hide: hide,
        cancelPromise: cancelPromise,
        isActive: self.isActive,
        panelRef: self.panelRef,
    };
}